import { render, staticRenderFns } from "./TdxTable.vue?vue&type=template&id=cf433e4e&scoped=true&"
import script from "./TdxTable.vue?vue&type=script&lang=ts&"
export * from "./TdxTable.vue?vue&type=script&lang=ts&"
import style0 from "./TdxTable.vue?vue&type=style&index=0&id=cf433e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf433e4e",
  null
  
)

export default component.exports